// Daten-getriebene Landingpages für PasstDasDurch.de (PRD §14/§15).
// SeoLandingPage rendert daraus generisch. calculator: "fit" | null.
// Slugs synchron halten mit scripts/generate-sitemap.js.

export const GROUPS = {
  tuer: "Durch die Tür",
  eng: "Aufzug & Treppenhaus",
  grundlagen: "Grundlagen",
};

const VALUES = [
  "Größte Außenmaße des Möbelstücks (Breite, Höhe, Tiefe)",
  "Maße der engsten Stelle (Tür, Flur, Aufzug oder Treppenhaus)",
  "gewünschter Spielraum (locker, normal, knapp)",
];

const HOW =
  "Der Rechner prüft verschiedene Orientierungen deines Möbelstücks gegen die Engstelle und bewertet mit Sicherheitszuschlag, ob es wahrscheinlich passt, knapp wird oder nicht passt. Bei diagonalen Fällen und Treppenhäusern bleibt das Ergebnis bewusst vorsichtig.";

const MISTAKES = [
  "Nur Breite und Höhe messen, Tiefe und überstehende Teile vergessen.",
  "Keinen Spielraum einplanen. Plane mindestens 3 bis 5 cm ein.",
  "Beim Treppenhaus zu sicher rechnen. Kurven, Geländer und Türrahmen entscheiden vor Ort.",
];

const FAQ = [
  { q: "Wie viel Spielraum sollte ich einplanen?", a: "Plane mindestens 3 bis 5 cm ein. Bei engen Stellen lieber mehr, weil sich Möbel selten exakt gerade durchschieben lassen." },
  { q: "Hilft es, die Tür auszuhängen?", a: "Oft ja. Ein ausgehängtes Türblatt gibt ein bis zwei Zentimeter Breite und manchmal entscheidende Tiefe frei." },
  { q: "Kann man ein Möbelstück diagonal durch eine Tür drehen?", a: "Manchmal. Das geht nur, wenn vor und hinter der Tür genug Platz zum Drehen ist. Der Rechner weist auf diese Fälle hin." },
  { q: "Warum ist das Treppenhaus schwerer zu berechnen?", a: "Treppenhäuser haben Kurven, Podeste, Geländer und Türrahmen. Diese lassen sich rechnerisch nur grob erfassen, deshalb bleibt das Ergebnis vorsichtig." },
];

function page(slug, group, navLabel, h1, metaTitle, metaDescription, intro, forWhat, example, related) {
  return {
    slug,
    group,
    calculator: "fit",
    navLabel,
    h1,
    metaTitle,
    metaDescription,
    intro,
    forWhat,
    whichValues: VALUES,
    howItWorks: HOW,
    example,
    mistakes: MISTAKES,
    faq: FAQ,
    related,
  };
}

export const PAGES = {
  "passt-sofa-durch-tuer": page(
    "passt-sofa-durch-tuer",
    GROUPS.tuer,
    "Sofa durch die Tür",
    "Passt mein Sofa durch die Tür?",
    "Passt mein Sofa durch die Tür? Rechner mit Skizze",
    "Prüfe mit Möbelmaßen und Türmaßen, ob dein Sofa, Schrank oder Gerät durch Tür, Flur, Aufzug oder Treppenhaus passt.",
    "Mit dem Sofa-durch-die-Tür-Rechner prüfst du, ob dein Sofa durch eine Türöffnung, einen engen Flur oder ein Treppenhaus passt. Gib die Maße deines Sofas und der engsten Stelle ein.",
    "Für Sofas und Couches, die durch eine Tür oder einen Flur sollen.",
    {
      title: "Beispiel: Sofa 180 x 85 x 95 cm, Tür 90 x 200 cm",
      lines: [
        "Mit dem 85 x 95 cm Querschnitt passt das Sofa durch die 90er Tür.",
        "Die 180 cm Länge geht dabei durch die Tür hindurch.",
        "Mit etwa 3 cm Spielraum am kritischen Maß wird es eher knapp, miss genau nach.",
      ],
    },
    ["passt-couch-durch-tuer", "sofa-durch-tuer-berechnen", "passt-sofa-in-aufzug", "couch-durch-treppenhaus"]
  ),

  "passt-couch-durch-tuer": page(
    "passt-couch-durch-tuer",
    GROUPS.tuer,
    "Couch durch die Tür",
    "Passt meine Couch durch die Tür?",
    "Passt meine Couch durch die Tür? Rechner",
    "Prüfe mit den Maßen von Couch und Tür, ob deine Couch durch die Türöffnung oder den Flur passt.",
    "Mit dem Couch-durch-die-Tür-Rechner prüfst du schnell, ob deine Couch durch Tür oder Flur passt. Gib die größten Außenmaße ein.",
    "Für Couches und Ecksofas vor Umzug oder Kleinanzeigen-Kauf.",
    {
      title: "Beispiel: Couch 200 x 88 x 95 cm, Tür 86 x 198 cm",
      lines: ["Querschnitt 88 x 95 passt nicht gerade durch die 86er Tür.", "Hier hilft oft das Aushängen des Türblatts oder eine diagonale Drehung."],
    },
    ["passt-sofa-durch-tuer", "couch-durch-treppenhaus", "sofa-durch-tuer-berechnen"]
  ),

  "passt-schrank-durch-tuer": page(
    "passt-schrank-durch-tuer",
    GROUPS.tuer,
    "Schrank durch die Tür",
    "Passt mein Schrank durch die Tür?",
    "Passt mein Schrank durch die Tür? Rechner",
    "Prüfe mit Schrankmaßen und Türmaßen, ob dein Schrank durch die Tür passt oder demontiert werden muss.",
    "Mit dem Schrank-durch-die-Tür-Rechner prüfst du, ob dein Schrank durch die Tür passt. Türen und Schubladen rechnest du am besten separat.",
    "Für Kleiderschränke und Korpusse, oft mit Demontage-Option.",
    {
      title: "Beispiel: Schrank 100 x 200 x 60 cm, Tür 85 x 200 cm",
      lines: ["Aufrecht passt die Höhe nicht. Liegend oder gekippt prüfen.", "Türen und Schubladen vorher entfernen spart Breite und Gewicht."],
    },
    ["passt-sofa-durch-tuer", "passt-kuehlschrank-durch-tuer", "moebel-durch-treppenhaus-rechner"]
  ),

  "passt-waschmaschine-durch-tuer": page(
    "passt-waschmaschine-durch-tuer",
    GROUPS.tuer,
    "Waschmaschine durch die Tür",
    "Passt meine Waschmaschine durch die Tür?",
    "Passt meine Waschmaschine durch die Tür? Rechner",
    "Prüfe mit den Maßen von Waschmaschine und Tür, ob das Gerät durch die Türöffnung passt.",
    "Mit diesem Rechner prüfst du, ob deine Waschmaschine durch die Tür passt. Anschlüsse und überstehende Teile mitmessen.",
    "Für Waschmaschinen und Trockner beim Transport in Bad oder Keller.",
    {
      title: "Beispiel: Waschmaschine 60 x 85 x 60 cm, Tür 70 x 200 cm",
      lines: ["Der 60 x 60 Querschnitt passt mit Spielraum durch die 70er Tür.", "Achte auf den Türgriff und die Schwelle."],
    },
    ["passt-kuehlschrank-durch-tuer", "passt-sofa-in-aufzug", "moebel-durch-treppenhaus-rechner"]
  ),

  "passt-kuehlschrank-durch-tuer": page(
    "passt-kuehlschrank-durch-tuer",
    GROUPS.tuer,
    "Kühlschrank durch die Tür",
    "Passt mein Kühlschrank durch die Tür?",
    "Passt mein Kühlschrank durch die Tür? Rechner",
    "Prüfe mit den Maßen von Kühlschrank und Tür, ob das Gerät durch die Türöffnung passt.",
    "Mit diesem Rechner prüfst du, ob dein Kühlschrank durch die Tür passt. Griffe und Scharniere beachten.",
    "Für Kühl- und Gefrierschränke beim Transport.",
    {
      title: "Beispiel: Kühlschrank 60 x 185 x 65 cm, Tür 80 x 200 cm",
      lines: ["Aufrecht passt der 60 x 65 Querschnitt durch die 80er Tür.", "Kühlschränke vor dem Kippen abtauen und einige Stunden stehen lassen."],
    },
    ["passt-waschmaschine-durch-tuer", "passt-schrank-durch-tuer", "passt-sofa-in-aufzug"]
  ),

  "passt-matratze-durch-tuer": page(
    "passt-matratze-durch-tuer",
    GROUPS.tuer,
    "Matratze durch die Tür",
    "Passt meine Matratze durch die Tür?",
    "Passt meine Matratze durch die Tür? Rechner",
    "Prüfe mit den Maßen von Matratze und Tür, ob deine Matratze durch die Türöffnung passt.",
    "Mit diesem Rechner prüfst du, ob deine Matratze durch Tür oder Treppenhaus passt. Matratzen lassen sich oft leicht biegen.",
    "Für Matratzen und Lattenroste beim Umzug.",
    {
      title: "Beispiel: Matratze 140 x 20 x 200 cm, Tür 80 x 200 cm",
      lines: ["Hochkant passt der 20 x 140 Querschnitt locker.", "Beim Biegen vorsichtig sein, damit der Kern nicht knickt."],
    },
    ["passt-sofa-durch-tuer", "moebel-durch-treppenhaus-rechner", "sofa-durch-tuer-berechnen"]
  ),

  "passt-sofa-in-aufzug": page(
    "passt-sofa-in-aufzug",
    GROUPS.eng,
    "Sofa in den Aufzug",
    "Passt mein Sofa in den Aufzug?",
    "Passt mein Sofa in den Aufzug? Rechner",
    "Prüfe mit Möbelmaßen und Aufzugmaßen, ob dein Sofa durch die Aufzugtür passt und im Innenraum steht.",
    "Mit dem Aufzug-Rechner prüfst du Türbreite und Innenraum. Diagonal stellen ist nur mit ausreichend breiter Tür möglich.",
    "Für Sofas, Schränke und Geräte im Aufzug.",
    {
      title: "Beispiel: Sofa 180 x 70 x 70 cm, Aufzug Tür 80, innen 100 x 140 x 210 cm",
      lines: ["Durch die 80er Tür passt der 70 x 70 Querschnitt.", "Aufrecht steht das Sofa im Innenraum, die Türbreite ist das kritische Maß."],
    },
    ["passt-sofa-durch-tuer", "moebel-durch-treppenhaus-rechner", "passt-kuehlschrank-durch-tuer"]
  ),

  "moebel-durch-treppenhaus-rechner": page(
    "moebel-durch-treppenhaus-rechner",
    GROUPS.eng,
    "Möbel durch Treppenhaus",
    "Möbel durch das Treppenhaus: Rechner",
    "Möbel durch das Treppenhaus berechnen: Rechner",
    "Prüfe mit Möbelmaßen und Treppenhausmaßen, ob dein Möbelstück durch das Treppenhaus passt. Vorsichtige Orientierung.",
    "Mit dem Treppenhaus-Rechner bekommst du eine vorsichtige Einschätzung. Treppenbreite, Podest und lichte Höhe zählen am meisten.",
    "Für Möbel in Altbauten und engen Treppenhäusern.",
    {
      title: "Beispiel: Sofa 220 x 90 x 80 cm, Treppe 100 cm, Podest 120 x 120 cm",
      lines: ["Die Treppenbreite reicht, das Podest wird zum Drehen knapp.", "Hier entscheidet die Situation vor Ort, prüfe Geländer und Türrahmen."],
    },
    ["couch-durch-treppenhaus", "passt-sofa-in-aufzug", "passt-schrank-durch-tuer"]
  ),

  "sofa-durch-tuer-berechnen": page(
    "sofa-durch-tuer-berechnen",
    GROUPS.grundlagen,
    "Sofa durch Tür berechnen",
    "Sofa durch die Tür berechnen",
    "Sofa durch die Tür berechnen: so geht es",
    "So berechnest du, ob dein Sofa durch die Tür passt. Mit Möbelmaßen, Türmaßen und einer ehrlichen Einschätzung.",
    "Hier erfährst du, wie der Rechner arbeitet und worauf du beim Messen achtest. Trag deine Werte ein und prüfe das Ergebnis.",
    "Für alle, die verstehen wollen, wie sich der Durchgang berechnen lässt.",
    {
      title: "So rechnet der Rechner",
      lines: [
        "Er testet verschiedene Orientierungen des Sofas gegen die Türöffnung.",
        "Eine Seite muss durch die Breite, eine durch die Höhe passen.",
        "Bei knappen Fällen warnt der Rechner, statt falsche Sicherheit zu geben.",
      ],
    },
    ["passt-sofa-durch-tuer", "passt-couch-durch-tuer", "moebel-durch-treppenhaus-rechner"]
  ),

  "couch-durch-treppenhaus": page(
    "couch-durch-treppenhaus",
    GROUPS.eng,
    "Couch durch Treppenhaus",
    "Passt meine Couch durch das Treppenhaus?",
    "Couch durch das Treppenhaus: Rechner",
    "Prüfe mit Couch- und Treppenhausmaßen, ob deine Couch durch das Treppenhaus passt. Vorsichtige Einschätzung.",
    "Mit dem Treppenhaus-Rechner prüfst du Treppenbreite, Podest und lichte Höhe für deine Couch.",
    "Für Couches und Ecksofas in engen Treppenhäusern.",
    {
      title: "Beispiel: Couch 200 x 90 x 88 cm, Treppe 95 cm, Podest 110 x 110 cm",
      lines: ["Die Treppenbreite ist knapp, das Podest klein zum Drehen.", "Demontage der Füße und Aushängen von Türen kann entscheidend helfen."],
    },
    ["moebel-durch-treppenhaus-rechner", "passt-couch-durch-tuer", "passt-sofa-in-aufzug"]
  ),
};

export const PAGE_LIST = Object.values(PAGES);

export function getPage(slug) {
  return PAGES[slug] || null;
}
